import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import Combination from './combination';
import classnames from 'classnames';
import useConfig from '../../hooks/useConfig';
var cls = 'combination-list';

var CombinationList = function CombinationList(_ref) {
  var config = _ref.config,
      id = _ref.id,
      onClick = _ref.onClick,
      className = _ref.className,
      pid = _ref.pid,
      render = _ref.render;

  var _useConfig = useConfig(),
      createNamespace = _useConfig.createNamespace,
      prefixCls = _useConfig.prefixCls;

  var classes = classnames(createNamespace === null || createNamespace === void 0 ? void 0 : createNamespace(cls, prefixCls), className);
  var _config$combinations = config.combinations,
      combinations = _config$combinations === void 0 ? [] : _config$combinations;
  var clickHandler = useCallback(function (combinationId, combinationDeeplink) {
    onClick === null || onClick === void 0 ? void 0 : onClick({
      componentId: id,
      pid: pid,
      combinationId: combinationId,
      render: render,
      combinationDeeplink: combinationDeeplink
    });
  }, [id, onClick, pid, render]);
  return _jsx("div", Object.assign({
    className: classes,
    "data-pid": pid,
    "data-componentid": id
  }, {
    children: combinations.map(function (combination) {
      return _jsx(Combination, {
        pid: pid,
        combination: combination,
        onClick: clickHandler
      }, combination.wdId);
    })
  }));
};

export default CombinationList;